import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { isHttpError } from '@/common/utils/isHttpError';
import { LoopPlannerScenarioApi } from '@/features/planner/api/scenario';
import { plannerQueryKeys } from '@/features/planner/queryKeys';

const DEFAULT_RETRY_LIMIT = 3;

export const getScenarioQueryOptions = ({
  loopId,
  scenarioId,
  enabled = true,
}: {
  loopId: number;
  scenarioId: number;
  enabled?: boolean;
}) =>
  queryOptions({
    queryKey: plannerQueryKeys.scenarios.detail({ loopId, scenarioId }),
    queryFn: () =>
      LoopPlannerScenarioApi.getScenario({
        loopId,
        scenarioId,
        includeMetrics: true,
        includeItemCount: true,
      }),
    staleTime: 0,
    refetchOnWindowFocus: true,
    enabled,
    retry: (failureCount: number, error: unknown) =>
      isHttpError(error, 404) ? false : failureCount < DEFAULT_RETRY_LIMIT,
  });

export const useGetScenario = ({
  loopId,
  scenarioId,
  enabled,
}: {
  loopId: number;
  scenarioId: number;
  enabled?: boolean;
}) => {
  return useQuery(getScenarioQueryOptions({ loopId, scenarioId, enabled }));
};

export const useGetScenarioSuspense = ({
  loopId,
  scenarioId,
}: {
  loopId: number;
  scenarioId: number;
}) => {
  return useSuspenseQuery(getScenarioQueryOptions({ loopId, scenarioId }));
};
